import { Record } from 'immutable';

const keys = {
  displayName: '',
  name: '',
};

interface Fields {
  displayName: string;
  name: string;
}

export default class CountryTimeZoneRecord extends Record<Fields>(keys) {}
